import { Box } from '@mantine/core';
import { IconPackage, IconShieldCheck, IconSettings, type IconProps } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import type { ProductKey } from '../types/entitlements';
import { tokens } from '../theme';

type Props = {
  productKey: ProductKey;
  accent: string;
  size?: number;
  muted?: boolean;
};

const ICONS: Record<ProductKey, (p: IconProps) => ReactNode> = {
  'foundry-flow': (p) => <IconPackage {...p} />,
  guardian: (p) => <IconShieldCheck {...p} />,
  'org-control-panel': (p) => <IconSettings {...p} />,
  'foundry-studio': (p) => <IconPackage {...p} />,
};

export function ProductIcon({ productKey, accent, size = 44, muted = false }: Readonly<Props>) {
  const icon = ICONS[productKey];
  const accentBorder = `${accent}3D`;
  return (
    <Box
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: 12,
        background: muted ? 'rgba(255, 255, 255, 0.04)' : `${accent}1F`,
        border: `1px solid ${muted ? tokens.navyBorder : accentBorder}`,
        color: muted ? tokens.textSubtle : accent,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: muted ? 'none' : `inset 0 0 18px ${accent}1A`,
      }}
    >
      {icon({ size: Math.round(size * 0.5), stroke: 1.6 })}
    </Box>
  );
}
